module.exports = __webpack_public_path__ + "static/media/icon_specifications.8611448c.svg";